/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn20_more_square': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M.917 5.833A4.917 4.917 0 015.833.917h8.334a4.917 4.917 0 014.916 4.916v8.334a4.917 4.917 0 01-4.916 4.916H5.833a4.917 4.917 0 01-4.916-4.916V5.833zm4.916-3.416a3.417 3.417 0 00-3.416 3.416v8.334a3.417 3.417 0 003.416 3.416h8.334a3.417 3.417 0 003.416-3.416V5.833a3.417 3.417 0 00-3.416-3.416H5.833zm-.39 6.443a1.167 1.167 0 100 2.334 1.167 1.167 0 000-2.334zm4.584 0a1.167 1.167 0 100 2.334 1.167 1.167 0 000-2.334zm4.53-.054a1.167 1.167 0 100 2.334 1.167 1.167 0 000-2.334z" _fill="#000"/>'
  }
})
